import barba from '@barba/core';


function servicesAccordion()
{
    const servicesAccordions = document.querySelectorAll('.serviceAccordion');

    if (servicesAccordions.length > 0)
    {
        [...servicesAccordions].forEach((element, index) => {
            const toggle = element.querySelector('.serviceAccordion__toggle');
            const toggleTarget = element.querySelector('.serviceAccordion__detail');
    
            toggle.addEventListener("click", (e) => {
                if (toggle.classList.contains('accordion--open'))
                {
                    toggle.classList.remove('accordion--open');
                    toggleTarget.classList.remove('accordion--open');
                }
                else
                {
                    toggle.classList.add('accordion--open');
                    toggleTarget.classList.add('accordion--open');
                }
            });
        });
    }
}


barba.hooks.enter((data) => {

    servicesAccordion();

});


servicesAccordion();